export default () => ({
  loading: true,
  notifications: null,
  currentNotification: null,
  totalItems: 0
})
